/**
 * AV API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CodeEntry } from './codeEntry';
import { GrundstueckId } from './grundstueckId';
import { HistInfo } from './histInfo';
import { TimePointId } from './timePointId';
import { Egrid } from './egrid';
import { GrundstueckNummerListEntry } from './grundstueckNummerListEntry';
import { GebaeudeArt } from './gebaeudeArt';
import { GrundstueckPermissions } from './grundstueckPermissions';


export interface GrundstueckListEntry { 
    id: GrundstueckId;
    egrid?: Egrid;
    grundstueckNummer?: GrundstueckNummerListEntry;
    grundstueckArt?: GrundstueckListEntry.GrundstueckArtEnum;
    sdrArt?: GrundstueckListEntry.SdrArtEnum;
    ligArt?: GrundstueckListEntry.LigArtEnum;
    codeUnterart?: CodeEntry;
    histInfo: HistInfo;
    flaecheQuadratMeter?: number;
    sonderrechtText?: string;
    flurnamen?: Array<string>;
    gebaeudeArten?: Array<GebaeudeArt>;
    grundstueckPDFpossible?: boolean;
    grundstueckRTFpossible?: boolean;
    dokulinkVerfuegbar?: GrundstueckListEntry.DokulinkVerfuegbarEnum;
    isKopie?: boolean;
    isNavigierbar?: boolean;
    isMeldungsrelevant?: boolean;
    permissions?: GrundstueckPermissions;
    flaechenMaessigNichtAusgeschieden?: boolean;
    haengigeGeschaefteIds?: Array<TimePointId>;
}
export namespace GrundstueckListEntry {
    export type GrundstueckArtEnum = 'STOCKWERK' | 'LIEGENSCHAFT' | 'MITEIGENTUM' | 'UNBEKANNT' | 'FOLIO' | 'BERGWERK' | 'SDR';
    export const GrundstueckArtEnum = {
        STOCKWERK: 'STOCKWERK' as GrundstueckArtEnum,
        LIEGENSCHAFT: 'LIEGENSCHAFT' as GrundstueckArtEnum,
        MITEIGENTUM: 'MITEIGENTUM' as GrundstueckArtEnum,
        UNBEKANNT: 'UNBEKANNT' as GrundstueckArtEnum,
        FOLIO: 'FOLIO' as GrundstueckArtEnum,
        BERGWERK: 'BERGWERK' as GrundstueckArtEnum,
        SDR: 'SDR' as GrundstueckArtEnum
    };
    export type SdrArtEnum = 'BAURECHT' | 'QUELLENRECHT' | 'KONZESSION' | 'UEBRIGES_RECHT';
    export const SdrArtEnum = {
        BAURECHT: 'BAURECHT' as SdrArtEnum,
        QUELLENRECHT: 'QUELLENRECHT' as SdrArtEnum,
        KONZESSION: 'KONZESSION' as SdrArtEnum,
        UEBRIGES_RECHT: 'UEBRIGES_RECHT' as SdrArtEnum
    };
    export type LigArtEnum = 'STR' | 'CFA' | 'DPI' | 'VEC' | 'VIC' | 'ADG' | 'UEBRIGEART';
    export const LigArtEnum = {
        STR: 'STR' as LigArtEnum,
        CFA: 'CFA' as LigArtEnum,
        DPI: 'DPI' as LigArtEnum,
        VEC: 'VEC' as LigArtEnum,
        VIC: 'VIC' as LigArtEnum,
        ADG: 'ADG' as LigArtEnum,
        UEBRIGEART: 'UEBRIGEART' as LigArtEnum
    };
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        DOKULINK_VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        DOKULINK_NICHT_VORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
}


